export const ContentList = [
  {
    name: "VEGITARIAN",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=514,fit=crop/wp-content/uploads/Beans-and-Greens-Tacos-5.jpg",
  },
  {
    name: "SUMMER",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=514,fit=crop/wp-content/uploads/Mango-Kiwi-Coolers-3.jpg",
  },
  {
    name: "QUICK AND EASY",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=514,fit=crop/wp-content/uploads/Mojo-Bowls-1.jpg",
  },
  {
    name: "SALADS",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=514,fit=crop/wp-content/uploads/Miso-Crunch-Salad-62.jpg",
  },
];


export const RoundImageList = [
  {
    name: "PASTA",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=514,fit=crop/wp-content/uploads/Vegan-Pasta-with-Walnut-Pesto-6.jpg",
  },
  {
    name: "SUMMER",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=514,fit=crop/wp-content/uploads/Golden-Grahams-Bars.jpg",
  },
  {
    name: "HEALTHY",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=514,fit=crop/wp-content/uploads/Coconut-Oil-Granola-2.jpg",
  },
  {
    name: "DINNER",
    image:
      "https://pinchofyum.com/cdn-cgi/image/width=360,height=514,fit=crop/wp-content/uploads/Juicy-Lucy-Inside.jpg",
  },
  {
    name: "INSTANT POT",
    image:
      "https://pinchofyum.com/wp-content/uploads/Italian-Beef-Sandwiches-5-400x400.jpg",
  },
  {
    name: "VEGAN",
    image:
      "https://pinchofyum.com/wp-content/uploads/Rainbow-Rolls-4-400x400.jpg",
  },
  {
    name: "MEAL PREP",
    image:
      "https://pinchofyum.com/wp-content/uploads/Winter-Grain-Bowl-400x400.jpg",
  },
  {
    name: "SOUPES",
    image:
      "https://pinchofyum.com/wp-content/uploads/Sopa-Tarasca-1-2-400x400.jpg",
  },
  {
    name: "HEALTHY",
    image:
      "https://pinchofyum.com/wp-content/uploads/Summer-Cobb-Salad-in-Bowl-400x400.jpg",
  },
];